import {
  CREATE_DOCUMENT_TYPE_SUCCESS,
  FETCH_DOCUMENT_TYPE_SUCCESS,
  GET_DOCUMENT_TYPE_SUCCESS,
  SAVE_DOCUMENT_TYPE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_DOCUMENT_TYPE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_DOCUMENT_TYPE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_DOCUMENT_TYPE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_DOCUMENT_TYPE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
